<template>
    <div id="credit-card" class="content-spacer">
        <ViewHeader title="Credit Card Payment" />
        <div id="rest-of-body" class="drop-shadow-sides">
            <TotalDetail :isTipVisible="true" />
            <div ref="i4goFrame" id="i4goFrame" />
            <form id="form-main">
                <input id="i4go_response" name="i4go_response" type="hidden" />
                <input id="i4go_responsecode" name="i4go_responsecode" type="hidden" />
                <input id="i4go_responsetext" name="i4go_responsetext" type="hidden" />
                <input id="i4go_cardtype" name="i4go_cardtype" type="hidden" />
                <input id="i4go_maskedcard" name="i4go_maskedcard" type="hidden" />
                <input id="i4go_uniqueid" name="i4go_uniqueid" type="hidden" />
                <input id="i4go_expirationmonth" name="i4go_expirationmonth" type="hidden" />
                <input id="i4go_expirationyear" name="i4go_expirationyear" type="hidden" />
                <input id="i4go_cardholdername" name="i4go_cardholdername" type="hidden" />
                <input id="i4go_streetaddress" name="i4go_streetaddress" type="hidden" />
                <input id="i4go_postalcode" name="i4go_postalcode" type="hidden" />
                <input id="i4go_extendedcarddata" name="i4go_extendedcarddata" type="hidden" />
                <input id="i4go_utoken" name="i4go_utoken" type="hidden" />
            </form>
            <label class="shift4-custom-elements shift4-label" for="shift4-csc">Card Security Code</label>
            <input id="shift4-csc" v-model="shift4Csc" @keypress="shift4CscKeypress" class="shift4-custom-elements shift4-csc" type="password" pattern="\d*" size="3" required maxlength="4" />
            <div v-if="!isCscValid" class="shift4-custom-elements error-message">
                Invalid Card Security Code.
            </div>
            <button id="shift4-submit-payment" class="shift4-custom-elements button-primary" type="submit">Submit payment</button>
        </div>
    </div>
</template>
<script>
    require("@/scripts/jquery.i4goTrueToken-wallets.js");
    require("@/scripts/jquery.cardswipe.js");

    import $ from "jquery";
    import axios from "axios";
    import ViewHeader from "../components/ViewHeader";
    import TotalDetail from "../components/TotalDetail";
    import { mapState, mapGetters, mapMutations } from "vuex";
    import { showBlocker } from "../mixins/show-blocker";
    import { paymentMethods } from "../constants/payment-methods";

    let observer;

    export default {
        name: "CreditCardShift4",
        components: {
            ViewHeader,
            TotalDetail
        },
        mixins: [showBlocker],
         data() {
            return {
                shift4Csc: "",
                isCscValid: true,
            }
        },
        computed: {
            ...mapState({
                siteId: state => state.session.siteId,
                accountId: state => state.session.accountId,
                checkId: state => state.session.checkId,
                tip: state => state.session.tip
            }),
            ...mapGetters([
                "balanceWithTip"
            ])
        },
        methods: {
            ...mapMutations([
                "setLoadingStatus",
                "setPayment"
            ]),
            shift4CscKeypress(){
                if (!/\d/.test(event.key)){
                    event.preventDefault();
                    return false;
                }
            },
            async setupShift4CreditCardPayment() {
                const authorizeUrl = "/shift4/authorizeclient/" + this.accountId + "/" + this.siteId + "/" + this.balanceWithTip;
                let authorizationData;

                this.setLoadingStatus(true);

                await axios.get(authorizeUrl)
                    .then(response => {
                        if (response.data) {
                            authorizationData = response.data;
                        }
                        else {
                            this.setLoadingStatus(false);
                            this.$router.push("/error/1027");
                            return;
                        }
                    })
                    .catch(error => {
                        console.error("Error authorizing client - " + error);
                        this.setLoadingStatus(false);

                        if (error.response &&
                            error.response.data &&
                            error.response.data.errorCode) {
                            this.$router.push("/error/" + error.response.data.errorCode);
                        }
                        else {
                            this.$router.push("/error/1027");
                        }

                        return;
                    });

                const vm = this;
                var i4goTrueTokenObj = $("#form-main").i4goTrueToken({
                    debug: true,
                    url: authorizationData.i4mUrl,
                    server: authorizationData.server,
                    accessBlock: authorizationData.accessBlock,
                    self: document.location,
                    template: "bootstrap4",
                    language: "en",
                    submitButton: { visible: false },
                    encryptedOnlySwipe: false,
                    onSuccess: () => {
                        console.log("Credit card payment initialization succeeded!");
                        this.sendPayloadToServer();
                    },
                    onFailure: () => {
                        console.warn("Credit card payment initialization failed!");
                        vm.shift4Csc = "";
                        vm.stopProgressIndicator();
                    },
                    cvv2Code: { visible: false }
                });

                $("#shift4-submit-payment").click(function () {
                    event.preventDefault();
                    vm.isCscValid = true;

                    if (vm.shift4Csc.length < 3){
                        vm.isCscValid = false;
                    }
                    else {
                        vm.startProgressIndicator();
                        i4goTrueTokenObj.submit();
                    }
                });

                $.cardswipe({
                    success: function (data) {
                        i4goTrueTokenObj.sendSwipeToFrame(data);
                    },
                    error: function () {
                        console.warn("Swipe failed!");
                    }
                });

                // We wanted to wait for the i4goFrame to load Shift4 iframe before we hide the loading indicator.
                // We used MutationObserver to check if the iframe has been loaded. If the browser do not support
                // MutationObserver or for some reason it failed loading, we'll remove the loading indicator
                // after a few seconds.
                if (!window.MutationObserver)
                {
                    console.debug("MutationObserver not supported.");
                    setTimeout(() => { this.setLoadingStatus(false); }, 3000);
                }
            },
            sendPayloadToServer() {
                console.log("Started processing payment..");
                const csc = this.shift4Csc;

                /* Card Security Code (CSC) Indicator values
                   0 - CSC not provided by user.
                   1 - CSC provided.
                   2 - CSC illegible.
                   9 - CSC not on card, or card did not have a CSC. */
                const securityCode = {
                    indicator: "1",
                    value: csc
                }

                let oePayload =
                {
                    SiteId: this.siteId,
                    AccountId: this.accountId,
                    CheckId: this.checkId,
                    PaymentAmount: this.balanceWithTip,
                    TipAmount: this.tip,
                    PaymentNonce: $("#i4go_uniqueid").val(),
                    SecurityCode: JSON.stringify(securityCode)
                }

                this.startProgressIndicator();

                axios.post("/payment/payment", oePayload)
                    .then(response => {
                        if (response.data) {
                            let payment = response.data;
                            payment.paymentName = paymentMethods.creditCard;
                            this.setPayment(payment);
                            this.$router.push("/paymentsummary");
                        }
                        else {
                            this.$router.push("/error/1010");
                        }
                    })
                    .catch(error => {
                        if (error.response &&
                            error.response.data &&
                            error.response.data.errorCode) {
                            switch (error.response.data.errorCode) {
                                case "1008":
                                case "1009":
                                case "1025":
                                    this.$router.push("/error/" + error.response.data.errorCode);
                                    break;
                                default:
                                    if (error.response.data.errorMessage) {
                                        console.error(error.response.data.errorMessage);
                                    }
                                    this.$router.push("/error/1010");
                            }
                        }
                        else {
                            console.error(error);
                            this.$router.push("/error/1010");
                        }
                    })
                    .finally(() => {
                        this.stopProgressIndicator();
                    });
            },
            setupMutationObserver() {
                // Mutation observer is used to detect if the iframe for Shift4 has loaded the form.
                // Once loaded, that's the time we want the loading indicator hidden.
                const targetNode = this.$refs.i4goFrame;

                // Options for the observer (which mutations to observe)
                const config = { attributes: false, childList: true, subtree: false };

                const callback = (mutationsList, observer) => {
                    console.debug("Mutations List", mutationsList);                    

                    $("#i4goFrame iframe").on("load", () => {
                        console.debug("Payment form loaded.");
                        this.setLoadingStatus(false);
                        observer.disconnect
                    });                    
                };

                observer = new MutationObserver(callback);
                observer.observe(targetNode, config);
            }
        },
        async mounted() {
            this.setupMutationObserver();
            await this.setupShift4CreditCardPayment()
        }
    }
</script>

<style scoped>
    #i4goFrame {
        padding: 18px 10px 0px 12px;
    }

    #credit-card {
        display: flex;
        flex-direction: column;
    }

    #rest-of-body {
        flex-grow: 1;
        background-color: white;
        padding-bottom: 60px;
    }

    .shift4-label {
        font-size: 14px;
        font-weight: normal;
        line-height: 20px;
        font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
        color: #333;
    }

    .shift4-custom-elements {
        display: block;
        text-align: left;
        margin-bottom: 5px;
        margin-left: 32px;
    }

    .shift4-csc {
        height: 18px;
        padding: 4px 6px;
        margin-bottom: 5px;
        font-size: 14px;
        line-height: 20px;
        color: #555;
        -webkit-border-radius: 4px;
        -moz-border-radius: 4px;
        border-radius: 4px;
        background-color: #fff;
        border: 1px solid #ccc;
        -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
        -moz-box-shadow: inset 0 1px 1px rgba(0,0,0,0.075);
        box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
        -webkit-transition: border linear .2s,box-shadow linear .2s;
        -moz-transition: border linear .2s,box-shadow linear .2s;
        -o-transition: border linear .2s,box-shadow linear .2s;
        transition: border linear .2s,box-shadow linear .2s;
    }

        .shift4-csc:focus {
            border-color: #66afe9;
            outline: 0;
            -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6);
            box-shadow: inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6);
        }

    .error-message {
        text-align: left;
    }

    .button-primary {
        margin-top: 15px;
        margin-bottom: 15px;
    }

</style>